import { useState, useEffect } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { formatDate } from "../utils";

import { usePymbleApi } from "./usePymbleApi";

// const MY_PERIODS_END_POINT = `${api.dtAdmin}/timetable/periods/`;
const MY_PERIODS_END_POINT = "/timetable/admin/period/";

export type PeriodDetail = {
  _id: string;
  PeriodId: string;
  Period: string;
  StartTime: string;
  StartTimeShort: string;
  TimetableType: string;
};

export type TimetableType = "Secondary" | "Junior" | "All";

/**
 * Hook for separate loading of timetable periods
 * for components
 */
export function useTimetablePeriods(
  calendarDate: string,
  timetableType: TimetableType
) {
  const [myPeriods, setMyPeriods] = useState<any>([]);
  const [myPeriodsLoaded, setMyPeriodsLoaded] = useState(false);

  const queryClient = useQueryClient();

  const { callApiS2: callApi, isAuthenticated } = usePymbleApi();

  // Load the list from api
  const calDate = formatDate(calendarDate);
  let queryKey = ["my-timetable-periods", calDate, timetableType];

  const { isLoading, isError, data, error } = useQuery({
    queryKey,
    queryFn: () =>
      callApi(
        "GET",
        MY_PERIODS_END_POINT + `?tt_date=${calDate}&tt_type=${timetableType}`,
      ),
    enabled: isAuthenticated,
  });

  // When the data is loaded, set the state
  useEffect(() => {
    if (data && data.length) {
      let list = preProcessPeriods(data);

      // Sort by name
      list = sortPeriods(list);

      if (list) {
        setMyPeriods(list);
      }
      setMyPeriodsLoaded(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data && !isLoading]);

  const refreshMyPeriods = async () => {
    queryClient.invalidateQueries({ queryKey });
  };

  // Only sort by start time at the moment
  const sortPeriods = (data: PeriodDetail[]) => {
    return data.sort(function (a: PeriodDetail, b: PeriodDetail) {
      try {
        if (a && a?.StartTime && b && b?.StartTime) {
          var NameA = a?.StartTime;
          var NameB = b?.StartTime;
          if (NameA < NameB) {
            return -1;
          }
          if (NameA > NameB) {
            return 1;
          }
        }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (e) {
        /* squash */
      }
      // names must be equal or documents incorrect
      return 0;
    });
  };

  // Decorate as required
  const preProcessPeriods = (classdata: any) => {
    return classdata.map((c: any) => {
      return c;
    });
  };

  return {
    isError,
    error,
    myPeriods,
    refreshMyPeriods,
    myPeriodsLoaded,
  };
}
